VLW.controllers.Home = class extends VLW.controllers.defaultPage {
	constructor(a, b) {
		super(a, b);
		CONFIG.INTRO_DONE ===false && broadCaster.INTROPAGE.add(this.onMainIntroOK);
		this.pixi                    = new VLW.HomePIXI(this.constructor.getPixiOption());
		this.pixi.align              = "tl";
		this.pixi.displacementType   = VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_HOME;
		this.pixi.containerMain.name = this.mainElementJS.getAttribute("data-code");
		this.video      = this.mainElementJS.querySelector("._video");
		this.loadPIXIResources();
		this.constructor.setStyleMenuHover("color_black");
		this.video && this.video.addEventListener("click",this.onClickVideo);
		this.unsetBouteilleContainer();
	}

	static getPixiOption(){
		return {};
	}
	unsetBouteilleContainer(){
		window.containerBouteille && TweenMax.to(window.containerBouteille, .5, {alpha: 0, onComplete: (elt) => {PIXIAPP.app.stage.removeChild(elt);}, onCompleteParams: [window.containerBouteille]});
		window.containerBouteille = null;
	}
	setSplitText(){
		this.mySplitText  = this.qsa("._texte .__wrap")		.length>0? new SplitText(this.qsa("._texte ._wrap")			, {type: "lines", linesClass: "_lines"}):{lines:{}};
		this.mySplitText2 = this.qsa("._plus span,._plus a").length>0? new SplitText(this.qsa("._plus span,._plus a")	, {type: "chars", linesClass: "_lines"}):null;
	}
	onRender(){
		super.onRender();
		this.setSplitText();
		this.setPlus();

	}
	setPlus(){
		if(VERSION_SMARTP || !this.plus)return;
		document.body.appendChild(this.plus);
		this.plus.querySelector("._wrap h1") && this.plus.querySelector("._texte").parentNode.insertBefore(this.plus.querySelector("._wrap h1"),this.plus.querySelector("._texte"));
	}

	onClickPlus(e){
		this.introPlus(0);
	}
	onClickPlusClose(e){
		let tl = new TimelineMax();
		tl.to(this.plus.querySelector("._content_plus"),.75,{opacity:0,ease:Sine.easeOut});
		tl.to(this.plus,1.25,{clearProps:"opacity",opacity:0,className:"-=__display",ease:Sine.easeInOut},"-=.5");
		tl.fromTo(this.mainElementJS,.75,{rotationX:0,rotationY:0,opacity:0},{opacity:1,ease:Sine.easeOut},"-=.5");
		tl.to(this.mainElementJS.querySelectorAll("._texte,._plus,._logo svg"),1.5,{y:0,ease:Sine.easeOut},"-=.5");
		tl.to(this.mainElementJS.querySelectorAll("._texte,._plus,._logo svg"),1.5,{opacity:1,ease:Sine.easeInOut},"-=1.25");
		tl.set(this.mainElementJS.querySelector("._content"),{overflow:"initial"},3);
	}

	onClickVideo(){
		SITE_VIDEO.display();
	}

	getPIXIResourcesBackground(){
		let _jsonBack = JSON.parse(this.mainElementJS.getAttribute("data-background"));
		let _image    = VERSION_SMARTP && _jsonBack.BackgroundSmartphone ? _jsonBack.BackgroundSmartphone : _jsonBack.Background;
		return _image.image;

	}
	loadPIXIResources(){
		if(this.mainElementJS.getAttribute("data-background")) {
			let _loader   = new PIXI.loaders.Loader();
			_loader.add("image", this.getPIXIResourcesBackground());
			_loader.load((loader, resources) => {
				this.pixi.resources = resources;
				loader.destroy();
			});
		}
	}

	onMainIntroOK(){
		if(!this.onMainIntroOK)return;
		broadCaster.INTROPAGE.remove(this.onMainIntroOK);
		if(this.pixi) {
			PIXIAPP.aToRender.push(this.pixi);
			this.pixi.introFirst();
			this.introContent(1.25);
		}
	}

	introPlus(delay=0){
		this.plus.querySelectorAll("._filet").map((elt)=>elt.classList.remove("__transitionable"));
		//let mySplitText  = new SplitText(this.plus.querySelectorAll("._texte ._wrap")		, {type: "lines", linesClass: "_lines"});
		let mySplitText2 = this.plus.querySelectorAll("._plus span").length>0? new SplitText(this.plus.querySelectorAll("._plus span")	, {type: "chars", linesClass: "_lines"}):null;
		let tl            = new TimelineMax({delay});

		tl.timeScale(1);
		tl.addLabel("start");
		tl.set(this.plus										,{opacity:1,className:"+=__display"});
		tl.set(this.plus.querySelector("._content_plus")				,{opacity:1});
		tl.set(this.mainElementJS.querySelector("._content")	,{overflow:"hidden"});

		tl.fromTo(this.plus.querySelectorAll("._filetIntro")			,1.75	,{opacity:1,scaleY:0	,transformOrigin:"0% 37%"}		,{scaleY:1,ease:Power4.easeInOut}			,"start+=0");
		tl.fromTo(this.mainElementJS									,1	,{opacity:1,y:0,transformPerspective:1000,transformOrigin:"100% 100%"}	,{opacity:0,ease:Sine.easeInOut}										,"start");
		tl.fromTo(this.mainElementJS.querySelectorAll("._texte,._plus")	,1	,{opacity:1,y:0,transformOrigin:"0% 0%"}	,{opacity:0,y:-.75*(this.mainElementJS.querySelector("._content").getBoundingClientRect().height),ease:Sine.easeInOut}	,"start");
		tl.fromTo(this.mainElementJS.querySelectorAll("._logo svg")		,1	,{opacity:1,y:0,transformOrigin:"0% 0%"}	,{opacity:0,y:.75*(this.mainElementJS.querySelector("._logo").getBoundingClientRect().height),ease:Sine.easeInOut}		,"start");

		tl.addLabel("filetIntro","-=1.25");
		tl.staggerFromTo(this.plus.querySelectorAll(".plus_image,.plus_texte")	,1.25,{opacity:0}	,{opacity:1,ease:Power2.easeIn},.25,"filetIntro");
		tl.fromTo(this.plus.querySelectorAll(".plus_image ._image")		,1.75,{opacity:1,x:"-15%",scale:1.05,transformOrigin:"100% 50%"}	,{opacity:1,x:"0%",scale:1.05,ease:Power2.easeOut},"filetIntro");
		tl.addLabel("voile","-=1");
		tl.fromTo(this.plus.querySelectorAll(".plus_texte ._voile"),2.5,{opacity:1,scale:1,transformOrigin:"50% 50%"}		,{delay:1,opacity:0,ease:Power2.easeInOut},"voile");
		tl.addLabel("filet","voile+=1");
		tl.to(this.plus.querySelectorAll("._filetIntro")				,1.25,	{opacity:0,ease:Sine.easeOut}							,"filet");
		tl.fromTo(this.plus.querySelectorAll("._filet._top")			,.75,	{y:25} ,{y:0,ease:Sine.easeInOut}						,"filet");
		tl.fromTo(this.plus.querySelectorAll("._filet._bottom")			,.75,	{y:-25},{y:0,ease:Sine.easeInOut}						,"filet");
		tl.fromTo(this.plus.querySelectorAll("._doubleFilet._bottom")	,.75,	{y:-25},{y:0,ease:Sine.easeInOut}						,"filet");
		tl.fromTo(this.plus.querySelectorAll("._filet")					,.75,	{opacity:0},{opacity:.7,ease:Sine.easeInOut}			,"filet");
		tl.staggerFromTo(this.plus.querySelectorAll("._filet")			,.75,	{scaleX:.01},{scaleX:1,ease:Sine.easeInOut,clearProps:"transform",onComplete:()=>{this.plus && this.plus.querySelectorAll("._filet").map((elt)=>elt.classList.add("__transitionable"))}}	,.1,"filet+=0");
		tl.addLabel("texte","filet+=0");
		tl.staggerFromTo(this.plus.querySelectorAll("._texte ._wrap")		,1		,{opacity:0}			,{opacity:1,ease:Sine.easeIn}	,.25,"texte-=.5");
		tl.staggerFromTo(this.plus.querySelectorAll("._texte ._wrap")		,1.25	,{y:15,rotation:5,transformOrigin:"50% 0%"}	,{smoothOrigin:true,rotation:0,transformOrigin:"0% 0%",y:0,ease:Sine.easeOut}		,.15,"texte-=.5");
		mySplitText2 && tl.staggerFromTo(mySplitText2.chars	,.75	,{opacity:0,x:15,rotation:5,transformOrigin:"50% 0%"}	,{opacity:1,smoothOrigin:true,rotation:0,transformOrigin:"0% 0%",x:0,ease:Sine.easeOut}		,.05,"texte+=0");
		return true;
	}

	animFilet(paused=false){
		let tl = new TimelineMax({paused});
		tl.addLabel("start");
		tl.fromTo(this.qsa("._filet._top")			,1.25,	{y:75}		,{y:0,ease:Sine.easeInOut}					,"start");
		tl.fromTo(this.qsa("._filet._bottom")		,1.25,	{y:-75}		,{y:0,ease:Sine.easeInOut}					,"start");
		tl.fromTo(this.qsa("._doubleFilet._bottom")	,1.25,	{y:-75}		,{y:0,ease:Sine.easeInOut}					,"start");
		tl.fromTo(this.qsa("._filet")				,1.25,	{opacity:0}	,{opacity:.7,ease:Sine.easeInOut}			,"start");
		tl.staggerFromTo(this.qsa("._filet")		,1.25,	{scaleX:.01},{scaleX:1	,ease:Sine.easeInOut,clearProps:"transform",onComplete:()=>{this.qsa && this.qsa("._filet").map((elt)=>elt.classList.add("__transitionable"))}}	,.1,"start+=1");
		this.mySplitText2 && tl.staggerFromTo(this.mySplitText2.chars	,.75	,{opacity:0,x:15,rotation:5,transformOrigin:"50% 0%"}	,{opacity:1,smoothOrigin:true,rotation:0,transformOrigin:"0% 0%",x:0,ease:Sine.easeOut}		,.05,"start+=1");
		return tl;
	}
	introContent(delay=0){
		let tl            = new TimelineMax({delay});
		VERSION_SMARTP?tl.to		(this.mainElementJS			,.75,{opacity:1}):tl.set		(this.mainElementJS			,{opacity:1});
		tl.addLabel	("start");
		tl.fromTo	(this.qsa("._logo")				,1.25,	{rotationX:35,transformOrigin:"0% 0%",opacity:0},{rotationX:0,opacity:1,ease:Sine.easeInOut}	,"start");
		tl.add		(this.animFilet()	,"start");
		tl.addLabel	("texte"			,"-=.25");
		tl.fromTo(this.qsa(".vlwScrollBar")			, 1.25, {opacity: 0}, {opacity: .7, ease: Sine.easeInOut}, "texte+=.75");
		//tl.staggerFromTo(this.mySplitText.lines		,1.5	,{opacity:0}			,{opacity:1,ease:Sine.easeIn}	,.25*.5,"texte-=.75");
		//tl.staggerFromTo(this.mySplitText.lines		,1.75	,{y:15,rotation:2.5		,transformOrigin:"50% 0%"}	,{smoothOrigin:true,rotation:0,transformOrigin:"0% 0%",y:0,ease:Sine.easeOut}		,.15*.5,"texte-=.75");
		tl.staggerFromTo(this.qsa("._coordonnees,._texte ._wrap h1,._texte ._wrap h2,._texte ._wrap h3,._texte ._wrap p")			,1.5	,{opacity:0}			,{opacity:1,ease:Sine.easeIn}	,.25*.5,"texte-=.75");
		tl.staggerFromTo(this.qsa("._coordonnees,._texte ._wrap h1,._texte ._wrap h2,._texte ._wrap h3,._texte ._wrap p")			,1.75	,{y:15,rotation:2.5		,transformOrigin:"50% 0%"}	,{smoothOrigin:true,rotation:0,transformOrigin:"0% 0%",y:0,ease:Sine.easeOut}		,.15*.5,"texte-=.75");
		return true;
	}

	outroPixi(){
		this.pixi.outro();
		this.pixi = null;
	}
	outroPlus(){
		this.plus&& TweenMax.killTweensOf(this.plus);
		this.plus&&	TweenMax.to(this.plus, .5, {opacity: 0, onComplete: (elt) => removeNode(elt), onCompleteParams: [this.plus]});
	}
	removeMenuListener(){
		broadCaster.MENU_HOVER.remove(this.onMenuHover);
		broadCaster.MENU_LEAVE.remove(this.onMenuLeave);
	}
	outro(){
		this.removeMenuListener();
		this.outroPixi();
		this.outroPlus();
		super.outro();
	}
	introPixi(delay=0){
		this.pixi.intro(delay);
	}

	intro() {
		CONFIG.INTRO_DONE ===true && this.introContent(.5) && this.introPixi(.5);
	}
};
